import { classes } from "@theme/helpers";
import { HTMLCustomElement } from "@theme/html-custom-element";
import { Swiper } from "@theme/swiper";

class FeaturedProduct extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.refs.swiper) {
      new Swiper(this.refs.swiper, {
        navigation: {
          nextEl: this.refs.next,
          prevEl: this.refs.prev,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        pagination: {
          el: this.refs.pagination,
          clickable: true,
          type: "fraction",
        },
      });
    }
  }
}

if (!customElements.get("featured-product"))
  customElements.define("featured-product", FeaturedProduct);
